import { Component, Input } from '@angular/core';
import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';
import { UntypedFormGroup } from '@angular/forms';
import { Shop } from '@pdqdev/pdq-shared/dist/entities/Shop';

@Component({
  selector: 'checkout-prioritization',
  templateUrl: './checkout-prioritization.component.html',
  styleUrls: ['./checkout-prioritization.component.scss'],
  standalone: false,
})
export class CheckoutPrioritizationComponent {
  @Input() settings: CheckoutSettings;
  @Input() shop: Shop;
  @Input() formGroup: UntypedFormGroup;

  constructor() {}
}
